<template>
  <div>
    <!-- <div @click="showRobot=true" class="mg-tip-container" id="openRobot">
      <img alt="" src="../../assets/img/robot.png" style="width: 100%">
    </div>
    <div class="robot_widow" id="robotWidow" v-show="showRobot">
      <div @click="showRobot=false" class="close_btn" id="closeBtn">x</div>
      <iframe class="robot_frame" id="robotFrame" :src="robotUrl"></iframe>
    </div> -->
  </div>
</template>

<script>
  export default {
    name: "Robot.vue"
    , props:["loginName"]
    , data() {
      return {
        showRobot: false
      }
    }
    , computed: {
      robotUrl() {
        let loginName = this.loginName;
        let url = 'https://helpdesk.brc.com.cn/chat/pc/index.html?sysNum=c7e9a12ad95d4fccb3c8450141ea8e5e&isFullScreen=1&isHideBtn=1&robotFlag=3&partnerId=';
        // console.log(loginName)
        // if (location.origin.indexOf('lotus.justbon.com') > -1) {
        //   url = 'https://helpdesk.brc.com.cn/chat/pc/index.html?sysNum=c7e9a12ad95d4fccb3c8450141ea8e5e&isFullScreen=1&isHideBtn=1&robotFlag=3&partnerId='
        // } else {
        //   url = 'http://10.0.11.202/chat/pc/index.html?sysNum=c889398aacd14e9db9582dda42342b47&isFullScreen=1&isHideBtn=1&robotFlag=3&partnerId='
        // }

        return url + window.encodeURIComponent(btoa(loginName))
      }
    }
  }
</script>

<style lang="scss">
  @import "../../assets/scss/views/robot";
</style>
